import { Type } from '@sinclair/typebox';
export var PoolEvent;
(function (PoolEvent) {
    PoolEvent["TopGainer"] = "top-gainer";
    PoolEvent["New"] = "new";
    PoolEvent["Trending"] = "trending";
    PoolEvent["Cooking"] = "cooking";
    PoolEvent["Graduated"] = "graduated";
    /**
     * Pools still on a bonding curve, closest to graduating first.
     *
     * Distinct from Cooking, which means "busy and rising in the last five
     * minutes" and says nothing about a curve. The two looked alike only
     * because Cooking's candidate query needs $10K of liquidity, which a pool
     * mid-curve does not have, so it returned migrated pools instead.
     */
    PoolEvent["FinalStretch"] = "final-stretch";
})(PoolEvent || (PoolEvent = {}));
export var PoolEventUpdateType;
(function (PoolEventUpdateType) {
    PoolEventUpdateType["Replace"] = "replace";
    PoolEventUpdateType["Append"] = "append";
    PoolEventUpdateType["UpdateExisting"] = "update-existing";
})(PoolEventUpdateType || (PoolEventUpdateType = {}));
export const PoolEventSchema = Type.Union([
    Type.Literal(PoolEvent.TopGainer),
    Type.Literal(PoolEvent.New),
    Type.Literal(PoolEvent.Trending),
    Type.Literal(PoolEvent.Cooking),
    Type.Literal(PoolEvent.Graduated),
    Type.Literal(PoolEvent.FinalStretch),
]);
export const PoolEventUpdateTypeSchema = Type.Union([
    Type.Literal(PoolEventUpdateType.Replace),
    Type.Literal(PoolEventUpdateType.Append),
    Type.Literal(PoolEventUpdateType.UpdateExisting),
]);
export const NEW_POOLS_REDIS_KEY_PREFIX = 'trade-api:new-pools';
export function buildNewPoolsKey(network) {
    return `${NEW_POOLS_REDIS_KEY_PREFIX}:${network}`;
}
//# sourceMappingURL=pool-event.js.map